import React from 'react';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _isString from 'lodash/isString';
import PropTypes from 'prop-types';
// Material UI
import MuiButtonBase from '@material-ui/core/ButtonBase';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
import MuiListItemText from '@material-ui/core/ListItemText';
import MuiMenu from '@material-ui/core/Menu';
import MuiMenuList from '@material-ui/core/MenuList';
import MuiMenuItem from '@material-ui/core/MenuItem';
// Custom
import { menuItemsShape } from 'constants/PropTypesShapes';
import { MenuMoreIconButton } from 'components/buttons/IconButtons';
import AppIcon from 'components/icons/AppIcon';
// Internal
import { getInternalLink } from './internal/Tools';

const MenuButton = ({
  buttonComp,
  Button,
  loading,
  items,
  obj,
  withoutObj,
  anchorOrigin,
  transformOrigin,
}) => {
  // Manage anchor element state
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (item) => {
    if (item.handleAction && (obj || withoutObj)) {
      item.handleAction(obj);
    }
    handleClose();
  };

  // Menu props
  let menuProps = { anchorEl, open: !!anchorEl, onClose: handleClose };
  if (anchorOrigin) {
    menuProps = { ...menuProps, anchorOrigin };
  }
  if (transformOrigin) {
    menuProps = { ...menuProps, transformOrigin };
  }
  return (
    <React.Fragment>
      {
        (buttonComp) ? (
          <MuiButtonBase onClick={handleClick}>
            <buttonComp.type {...buttonComp.props} />
          </MuiButtonBase>
        ) : (
          !Button && <MenuMoreIconButton onClick={handleClick} />
        )
      }
      {Button && <Button loading={loading} onClick={handleClick} />}
      <MuiMenu getContentAnchorEl={null} {...menuProps}>
        <MuiMenuList variant="menu" style={{ outline: 'none' }}>
          {_map(_filter(items, 'visible'), (item) => (
            <MuiMenuItem
              key={item.key}
              component={item.path ? getInternalLink(item.path) : 'li'}
              disabled={item.disabled}
              selected={item.selected}
              onClick={() => handleItemClick(item)}
            >
              {item.icon && (
                <MuiListItemIcon>
                  {_isString(item.icon) ? <AppIcon id={item.icon} /> : item.icon}
                </MuiListItemIcon>
              )}
              <MuiListItemText primary={item.label} secondary={item.secondaryLabel} />
            </MuiMenuItem>
          ))}
        </MuiMenuList>
      </MuiMenu>
    </React.Fragment>
  );
};

MenuButton.propTypes = {
  buttonComp: PropTypes.element,
  Button: PropTypes.func,
  loading: PropTypes.bool,
  items: menuItemsShape.isRequired,
  obj: PropTypes.object, // eslint-disable-line react/forbid-prop-types,
  withoutObj: PropTypes.bool,
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.string.isRequired,
    vertical: PropTypes.string.isRequired,
  }),
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.string.isRequired,
    vertical: PropTypes.string.isRequired,
  }),
};

MenuButton.defaultProps = {
  buttonComp: null,
  Button: null,
  loading: false,
  obj: null,
  withoutObj: false,
  anchorOrigin: null,
  transformOrigin: null,
};

export default React.memo(MenuButton);



// WEBPACK FOOTER //
// ./components/core/MenuButton.js